export default "__VITE_ASSET__GWc1IVeR__"